<template>
  <div class="effect-articles">
    <SectionLabel text="牽動選情"/>
    <!-- intro -->
    <!-- <div class="effect-articles__intro">
      <span>在所有投票權的人口數中，中年以上選民的政黨偏好固定不易鬆動，而年輕族群的政黨色彩較淡，比起黨派更關注議題與政見，因而成為左右選情的關鍵選民。能否翻轉既定政治版圖，就要看哪個陣營能夠獲得年輕族群的青睞。</span>
    </div> -->
    <!-- headline articles -->
    <div class="effect-articles__headline">
      <div class="effect-articles__item"
        v-for="article in articlesTop5"
        :key="article.id">
        <div class="effect-articles__content clearfix">
          <div class="effect-articles__photo"
            is="router-link"
            :to="`/article/${article.id}`"
            :title="article.title"
            @click="onClick(article.id)">
            <div class="effect-articles__photo-image"
              :style="`background-image: url(${article.image})`">
            </div>
          </div>
          <div class="effect-articles__overview">
            <div class="effect-articles__head">
              <h3 class="effect-articles__title"
                is="router-link"
                :to="`/article/${article.id}`"
                :title="article.title">{{ article.title }}
              </h3>
              <h4 class="effect-articles__subtitle">{{ article.subtitle }}</h4>
            </div>
            <div class="effect-articles__summary">{{ article.description | ellipsis(150) }}</div>
            <div class="effect-articles__detail"><!--
            --><OutlinesButton :link="`${baseUrl}article/${article.id}`" text="詳細內文" @click.native.prevent="onClick(article.id)"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionLabel from '@/components/SectionLabel'
import OutlinesButton from '@/components/OutlinesButton'
import articles from '@/data/articles'

export default {
  name: 'EffectArticles',
  components: {
    SectionLabel,
    OutlinesButton
  },
  filters: {
    line (text, lineNum = 0) {
      return text.split('\n')[lineNum] || ''
    }
  },
  inject: [ 'baseUrl' ],
  data () {
    return {
      articles
    }
  },
  computed: {
    articlesTop5 () {
      return this.articles.slice(0, 5)
    }
  },
  methods: {
    onClick (id) {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Link',
        'eventAction': 'Click',
        'eventLabel': `Link-to-article-${id}`
      })
      console.log(`@${this.$options.name} [linktoOtherPage]`)
      this.$router.push({ name: `article-${id}` })
    }
  }
}
</script>

<style lang="scss">
.effect-articles {
  $comp: &;
  // @include use-layer(&);
  position: relative;
  min-height: 100vh;
  padding-top: 50px;
  padding-bottom: 30px;
  background: #efefef;
  @include rwd($RWD_TABLET_SMALL) {
  }
  @include rwd($RWD_TABLET) {
    padding-top: 80px;
    padding-bottom: 30px;
  }
  @include rwd($RWD_DESKTOP) {
    padding-top: 72px;
    padding-bottom: 60px;
  }
  @include rwd($RWD_DESKTOP_WIDE) {
    padding-bottom: 70px;
  }

  &__intro {
    position: relative;
    margin: 20px 12px;
    font-size: 0.875em;
    font-weight: 600;
    font-family: "Noto Serif TC";
    line-height: 1.7142em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 30px 36px;
      font-size: 1em;
      line-height: 1.625em;
    }
    @include rwd($RWD_TABLET) {
      width: 520px;
      margin: 40px auto 0;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP) {
      width: 770px;
      margin: 30px auto 0;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 910px;
      margin: 55px auto 0;
    }
  }

  &__headline {
    margin-top: 44px;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 72px;
    }
    @include rwd($RWD_TABLET) {
      width: 520px;
      margin: 72px auto 0 auto;
    }
    @include rwd($RWD_DESKTOP) {
      width: 100%;
      max-width: 870px;
      margin: 64px auto 0 auto;
      padding: 0 50px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      max-width: 1190px;
      margin: 90px auto 0 auto;
    }
  }

  &__item {
    position: relative;

    // odd
    &:nth-child(2n + 1) {
      #{$comp}__photo {
        @include rwd($RWD_DESKTOP) {
          float: left;
          width: 55%;
        }

        &:after {
          @include rwd($RWD_DESKTOP_WIDE) {
            top: 46px;
            right: 46px;
          }
        }

        &-image {
          @include rwd($RWD_DESKTOP_WIDE) {
            bottom: 46px;
            left: 46px;
          }
        }
      }

      #{$comp}__overview {
        @include rwd($RWD_DESKTOP) {
          float: right;
          width: 45%;
          padding: 28px 30px 10px 40px;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          padding: 36px 20px 10px 60px;
        }
        &:before {
          @include rwd($RWD_DESKTOP_WIDE) {
            left: 7%;
            right: 0;
          }
        }
      }
    }

    // even
    &:nth-child(2n) {
      #{$comp}__photo {
        @include rwd($RWD_DESKTOP) {
          float: right;
          width: 55%;
        }

        &:after {
          @include rwd($RWD_DESKTOP) {
            left: 28px;
            right: 0;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            top: 46px;
            left: 46px;
          }
        }

        &-image {
          @include rwd($RWD_DESKTOP) {
            left: 0;
            right: 28px;
          }
          @include rwd($RWD_DESKTOP_WIDE) {
            bottom: 46px;
            right: 46px;
          }
        }
      }

      #{$comp}__overview {
        @include rwd($RWD_DESKTOP) {
          float: left;
          width: 45%;
          padding: 28px 35px 10px 30px;
        }
        @include rwd($RWD_DESKTOP_WIDE) {
          padding: 36px 54px 10px 30px;
        }
        &:before {
          @include rwd($RWD_DESKTOP_WIDE) {
            left: 0;
            right: 6%;
          }
        }
      }
    }

    // from 2rd
    &:nth-child(n + 2) {
      @include rwd($RWD_DESKTOP) {
        margin-top: 70px;
      }
      @include rwd($RWD_DESKTOP) {
        margin-top: 80px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        margin-top: 100px;
      }
    }

    // odd
    &:nth-child(2n) {
      #{$comp}__photo {
        &:after {
          background: #f6d18a;
        }
      }
    }

    /*
    // from 3rd for changing the background color of the article photos
    &:nth-child(n + 3) {
      #{$comp}__photo {
        &:after {
          background: #f6d18a;
        }
      }
    }

    // from 3rd for the article items layout on wide desktop
    &:nth-child(n + 3) {
      @include rwd($RWD_DESKTOP_WIDE) {
        display: inline-block;
        width: 33.33%;
        margin-top: 100px;
        padding: 0 26px;
        vertical-align: top;

        &:before {
          content: "";
          display: block;
          position: absolute;
          top: 46px;
          left: 0;
          width: 100%;
          height: 150px;
          background: #f6d18a;
        }
      }

      #{$comp}__content {
        @include rwd($RWD_DESKTOP_WIDE) {
        }
      }

      #{$comp}__photo {
        @include rwd($RWD_DESKTOP_WIDE) {
          float: none;
          width: auto;
        }
        &:after {
          @include rwd($RWD_DESKTOP_WIDE) {
            content: none;
            display: none;
          }
        }
        &-image {
          @include rwd($RWD_DESKTOP_WIDE) {
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
          }
        }
      }

      #{$comp}__overview {
        @include rwd($RWD_DESKTOP_WIDE) {
          float: none;
          width: auto;
          padding: 26px 6px 10px 6px;
        }
      }

      #{$comp}__title {
        @include rwd($RWD_DESKTOP_WIDE) {
          font-size: 1.5em;
          line-height: 1.5em;
        }
      }

      #{$comp}__subtitle {
        @include rwd($RWD_DESKTOP_WIDE) {}
      }

      #{$comp}__summary {
      }

      #{$comp}__detail {
        margin-top: 35px;
      }
    }

    &:nth-child(3) {
      #{$comp}__overview {
        &:before {
          @include rwd($RWD_DESKTOP_WIDE) {
            display: none;
          }
        }
      }
    }

    &:nth-child(n + 4) {
      #{$comp}__overview {
        &:before {
          @include rwd($RWD_DESKTOP_WIDE) {
            top: 0;
            bottom: auto;
            left: -26px;
            right: auto;
            width: 0;
            height: auto;
            min-height: 500px;
            border-top: none;
            border-left: 1px solid #e8a687;
          }
        }
      }
    }*/
  }

  &__content {
    position: relative;
    padding: 0 12px;
    @include rwd($RWD_TABLET_SMALL) {
      padding: 0 24px;
    }
    @include rwd($RWD_DESKTOP) {
      padding: 0;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
    }
  }

  &__photo {
    display: block;
    position: relative;
    @include use-fixed-ratio(4, 3);
    cursor: pointer;

    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 15px;
      bottom: 0;
      left: 0;
      right: 12px;
      background: #e8a687;
      @include rwd($RWD_TABLET_SMALL) {
        top: 20px;
        right: 20px;
      }
      @include rwd($RWD_TABLET) {
        top: 28px;
        right: 24px;
      }
      @include rwd($RWD_DESKTOP) {
        top: 35px;
        right: 28px;
      }
    }

    &-image {
      z-index: 1;
      position: absolute;
      top: 0;
      bottom: 15px;
      left: 12px;
      right: 0;
      background: #f1f1f1 no-repeat top center / cover;
      @include rwd($RWD_TABLET_SMALL) {
        bottom: 20px;
        left: 20px;
      }
      @include rwd($RWD_TABLET) {
        bottom: 28px;
        left: 24px;
      }
      @include rwd($RWD_DESKTOP) {
        bottom: 35px;
        left: 28px;
      }
    }
  }

  &__overview {
    position: relative;
    padding: 16px 12px 32px 12px;
    color: #1a1a1a;
    @include rwd($RWD_TABLET_SMALL) {
      padding: 32px 20px 32px 20px;
    }
    @include rwd($RWD_TABLET) {
      padding: 32px 20px 70px 20px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 6px;
    }

    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 5%;
      bottom: 5%;
      left: 0;
      width: 0;
      border-left: 1px solid #e8a687;
      @include rwd($RWD_TABLET_SMALL) {
        top: 10%;
      }
      @include rwd($RWD_DESKTOP) {
        top: 0;
        bottom: auto;
        left: 5%;
        right: 5%;
        width: auto;
        height: 0;
        border-left: none;
        border-top: 1px solid #e8a687;
      }
    }
  }

  &__title {
    color: #1a1a1a;
    font-size: 1.25em;
    font-weight: bold;
    line-height: 1.2em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1.875em;
      line-height: 1em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.875em;
      line-height: 1em;
    }
    @include rwd($RWD_DESKTOP) {
      font-size: 1.875em;
      line-height: 1.2em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      font-size: 2.25em;
      line-height: 1.2em;
    }
  }

  &__subtitle {
    margin-top: 10px;
    color: #dd6f6f;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.25em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 5px;
      font-size: 1.125em;
      line-height: 2em;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 10px;
      font-size: 1.25em;
      line-height: 1.5em;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 5px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 10px;
      font-size: 1.25em;
      line-height: 1.4em;
    }
    @include rwd($RWD_DESKTOP_WIDE_1660) {
      font-size: 1.375em;
      line-height: 1.363em;
    }
  }

  &__summary {
    margin-top: 10px;
    font-size: 0.875em;
    font-weight: bold;
    text-align: justify;
    text-justify: inter-word;
    line-height: 1.714em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 5px;
      font-size: 1em;
      line-height: 1.714em;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 13px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 10px;
      font-size: 1em;
      line-height: 1.5em;
      overflow: hidden;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 13px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
  }

  &__detail {
    width: 100%;
    margin-top: 22px;
    text-align: right;
    @include use-vertical-align();

    .outlines-button {
      vertical-align: middle;
      @include rwd($RWD_DESKTOP) {
        margin-right: 10px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        width: 160px;
        height: 45px;
      }
      &__text {
        @include rwd($RWD_DESKTOP_WIDE) {
          font-size: 1.125em;
        }
      }
    }
  }
}
</style>
